<template>
  <div class="container">
    <div class="background-container">
      <div v-for="(image, index) in backgroundImages" :key="index" class="image-wrapper">
        <el-image :src="image" class="background-image" fit="contain"></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      backgroundImages: [require('@/assets/images/jj-1.jpg'), require('@/assets/images/jj-2.jpg')],
    }
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  position: relative;
  width: 100%;
  overflow: hidden;
  text-align: center;
}

.background-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.image-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media screen and (max-width: 768px) {
  .image-wrapper {
    height: auto;
  }
  .background-image {
    width: 100%;
    height: auto;
  }
}
</style>
